import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./RerouteModalStyles.css";
import { AtomizerDeleteJob, AtomizerJobAPI } from "../../../API/api";
import { toast } from "react-toastify";
const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",
  display: "flex",
  justifyContent: "center",
  width: "100%"


};

export default function DeleteDocModal() {
  const [isLoading, isLoaded] = useState(false);
  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const modalState = useSelector((state) => state.domain);
  const ingestedState = useSelector((state) => state.drawer.tableDataCurrent);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, ingestedrefreshData ,RefreshAction} = bindActionCreators(Actions, dispatch);
  const onClickButtons = () => {
    isLoaded(true);
    if (ingestedState.newSoId === null) {
      let payload = {
        'deleteVerifiedQA': true,
        'deleteSuggestions': true,
        'deleteFile': true,
        'data': [
          {
            soId: ingestedState.soId
          }
        ],
        'type': ingestedState.docType === "urlcrawl" ? 'crawled' : ingestedState.docType === "Thread" ? 'threads' : ""
      }
      AtomizerDeleteJob(payload).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          toast.success(successMsg("Document deleted successfully!"));
          ingestedrefreshData(0);
          advanceFilterModalToggle({ bool: false, value: "" });
          isLoaded(false);
        }
      })
    } else {
      let payload = {
        action: "revert",
        data: [
          {
            "jobId": ingestedState.jobid,
            "soId": ingestedState.newSoId,
          }
        ]
      }
      AtomizerJobAPI(payload).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          toast.success(successMsg(res.data.message));
          ingestedrefreshData(0);
          advanceFilterModalToggle({ bool: false, value: "" });
          isLoaded(false);
        }
        ingestedrefreshData(0);
      })
    }
  }
  return (
    <Modal show={modalState.modalState}
      onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
      centered={true}
      size={"lg"}
      style={{ marginTop: "-50px" }}
    // scrollable={true}
    >
      {/* <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
                <ModalTitle>
                    <h5 className="headingModal"><i className="fa fa-trash" style={{ paddingRight: "7px", fontSize: "16px" }}></i>Delete Document?</h5>
                </ModalTitle>
            </ModalHeader> */}
      <Modal.Header closeButton>
        <Modal.Title style={modalTitleStyle}>
          <span>
            <i class="fa fa-trash" aria-hidden="true"> </i> &nbsp;&nbsp;Delete Document
          </span>


        </Modal.Title>
      </Modal.Header>
      <ModalBody>
        <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
          <div className="container">
            {ingestedState.newSoId === null && <p style={textStyles1}>Are you sure; you want to delete this document?</p>}
            {ingestedState.newSoId !== null && <p style={textStyles1}>This document has a new version.</p>}
            {ingestedState.newSoId !== null && <p style={textStyles1}>Do you want to delete new version of this document?</p>}

            {!isLoading && <div>
              <button style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: ' 0px 1px 2px 0px #1018280D',
                color: '#2A364A',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: " #F6F7F8",
                marginBottom: '14px',
                fontWeight: 400,
                border: " 1px solid #E0E2E6",
                cursor: "pointer",
                //  font-weight: 400;			
              }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: ' 0px 1px 2px 0px #1018280D',
                color: '#FFFFFF',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                marginBottom: '14px',
                fontWeight: 400,
                border: " 1px solid #E0E2E6",
                cursor: "pointer",
                //  font-weight: 400;			
              }} onClick={() => onClickButtons()}>Yes</button>
            </div>}
            {isLoading &&
              <div>

                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    cursor: "not-allowed",
                    opacity: "0.7"
                  }}
                  disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting</button>
              </div>}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}
